var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseTaskEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty state Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 634000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170",
    x: 81,
    y: 48,
    width: 35.9512,
    height: 49.288,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167",
    x: 86.2188,
    y: 77.4299,
    width: 26.0936,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173",
    x: 86.2188,
    y: 84.4299,
    width: 26.0936,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172",
    x: 86,
    y: 67,
    width: 26,
    height: 8,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171",
    x: 86,
    y: 51,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634001"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170_2",
    x: 16,
    y: 48,
    width: 35.9512,
    height: 49.288,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167_2",
    x: 34,
    y: 57,
    width: 14,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172_2",
    x: 20,
    y: 67,
    width: 28,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173_2",
    x: 20,
    y: 73,
    width: 28,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3174",
    x: 20,
    y: 79,
    width: 28,
    height: 8,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171_2",
    x: 20.2188,
    y: 52,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1667 38C90.7117 38.6908 96 43.411 96 60.9488V83.9744C96 99.3248 92.8333 107 77 107H58C42.1667 107 39 99.3248 39 83.9744V60.9488C39 43.4494 44.2883 38.6908 54.8333 38",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1667 38C90.7117 38.6908 96 43.411 96 60.9488V83.9744C96 99.3248 92.8333 107 77 107H58C42.1667 107 39 99.3248 39 83.9744V60.9488C39 43.4494 44.2883 38.6908 54.8333 38",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M66.9878 58H81",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51 59.0035L53.0017 61.0052L59.0069 55",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.9878 71H81",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M66.9878 84H81",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M51 72.0035L53.0017 74.0052L59.0069 68",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M51 85.0035L53.0017 87.0052L59.0069 81",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M59.75 45.25H75.25C83 45.25 83 41.375 83 37.5C83 29.75 79.125 29.75 75.25 29.75H59.75C55.875 29.75 52 29.75 52 37.5C52 45.25 55.875 45.25 59.75 45.25Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTaskEmpty);
export default __webpack_public_path__ + "static/media/closeTaskEmpty.401a6924d7c6c5c9511945e20ae7286d.svg";
export { ForwardRef as ReactComponent };